import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './order-date.hooks';

@Component({
	selector: 'app-order-date',
	templateUrl: './order-date.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class OrderDateComponent {
	testHooks = TestHooks;
	@ViewSelectSnapshot(SelectedMatter.titleInsuranceOrderedOn) orderedOn: string;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	@Input() labelClass = '';

	constructor(private matterDispatch: MatterDispatch) {}

	setOrderedOn(value: string): void {
		this.matterDispatch.SetTitleInsuranceOrderedOn(this.matterId, value);
	}
}
